import {
  DestroyRef,
  inject,
  Injectable,
  makeEnvironmentProviders,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslationKeys } from '../providers/transloco-provider';
import { TranslationService } from '../translation-service';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly destroyRef = inject(DestroyRef);
  private readonly translation = inject(TranslationService);

  private readonly appName = 'UPU Certification Platform';
  private readonly originalTitle = signal<TranslationKeys | undefined>(
    undefined,
  );

  constructor() {
    super();

    this.translation.langChangedAndReady$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.translatePageTitle(this.originalTitle()));
  }

  updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot) as TranslationKeys | undefined;

    this.originalTitle.set(title);
    this.translatePageTitle(title);
  }

  private translatePageTitle(title: TranslationKeys | undefined): void {
    if (!title) {
      return;
    }

    const translatedTitle = title ? this.translation.translate(title) : title;

    this.title.setTitle(`${translatedTitle} - ${this.appName}`);
  }
}

export const provideAppTitleStrategy = () =>
  makeEnvironmentProviders([
    {
      provide: TitleStrategy,
      useClass: AppTitleStrategy,
    },
  ]);
